import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const KEY = "sec_customer_token";
export const getCustToken = () => localStorage.getItem(KEY);
export const setCustToken = (t) => localStorage.setItem(KEY, t);
export const clearCustToken = () => localStorage.removeItem(KEY);

const h = () => ({ Authorization: `Bearer ${getCustToken()}` });

export const customerRegister = async (payload) =>
  (await axios.post(`${API}/auth/register`, payload)).data;
export const customerLogin = async (email, password) =>
  (await axios.post(`${API}/auth/login`, { email, password })).data;
export const customerMe = async () =>
  (await axios.get(`${API}/auth/me`, { headers: h() })).data;

export const forgotPassword = async (email) =>
  (await axios.post(`${API}/auth/forgot`, { email })).data;
export const resetPassword = async (token, password) =>
  (await axios.post(`${API}/auth/reset`, { token, password })).data;
export const uploadOrderImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${API}/uploads/customer`, fd, {
    headers: { ...h(), "Content-Type": "multipart/form-data" },
  });
  return `${BACKEND_URL}${data.url}`;
};

export const getOrdersConfig = async () => (await axios.get(`${API}/orders/config`)).data;
export const getMyOrders = async () => (await axios.get(`${API}/orders/mine`, { headers: h() })).data;
export const createOrder = async (payload) =>
  (await axios.post(`${API}/orders`, payload, { headers: h() })).data;
export const getMyBookings = async () => (await axios.get(`${API}/bookings/mine`, { headers: h() })).data;

// Admin orders
import { getToken } from "./api";
const ah = () => ({ Authorization: `Bearer ${getToken()}` });
export const adminGetOrders = async () => (await axios.get(`${API}/admin/orders`, { headers: ah() })).data;
export const adminSetOrderStatus = async (id, status) =>
  (await axios.patch(`${API}/admin/orders/${id}`, { status }, { headers: ah() })).data;
export const adminDeleteOrder = async (id) =>
  (await axios.delete(`${API}/admin/orders/${id}`, { headers: ah() })).data;
